import { assert, Notifier, UUID } from "@opendaw/lib-std";
import { EventCollection } from "@opendaw/lib-dsp";
import { MarkerBoxAdapter } from "./MarkerBoxAdapter";
import { MarkerBox } from "@opendaw/studio-boxes";
export class MarkerTrackAdapter {
    #context;
    #object;
    changeNotifier;
    #adapters;
    #events;
    #subscription;
    constructor(context, object) {
        this.#context = context;
        this.#object = object;
        this.changeNotifier = new Notifier();
        this.#adapters = UUID.newSet(adapter => adapter.uuid);
        this.#events = EventCollection.create(MarkerBoxAdapter.Comparator);
        this.#subscription = this.#object.markers.pointerHub.catchupAndSubscribe({
            onAdded: ({ box }) => {
                if (box instanceof MarkerBox) {
                    const adapter = this.#context.boxAdapters.adapterFor(box, MarkerBoxAdapter);
                    const added = this.#adapters.add(adapter);
                    assert(added, "Could not add adapter");
                    this.#events.add(adapter);
                    this.dispatchChange();
                }
            },
            onRemoved: ({ box: { address: { uuid } } }) => {
                this.#events.remove(this.#adapters.removeByKey(uuid));
                this.dispatchChange();
            }
        });
    }
    subscribe(observer) { return this.changeNotifier.subscribe(observer); }
    get context() { return this.#context; }
    get enabled() { return this.#object.enabled.getValue(); }
    get events() { return this.#events; }
    get object() { return this.#object; }
    dispatchChange() { this.changeNotifier.notify(); }
    onSortingChanged() {
        this.#events.onIndexingChanged();
        this.dispatchChange();
    }
    terminate() { this.#subscription.terminate(); }
}
